const DataLookup = 'DataLookup';

export const GetUsersInRegistrationList = `${DataLookup}/GetUsersInRegistrationList`;